<template>
  <div class="date-container">
    <div v-if="manualCompletionNote" class="manual-completion">
      <span>Completed: {{ parseTimestamp(date, undefined, "do MMM yyyy") }}</span>
      <span class="manual-completion-note" v-html="manualCompletionNote"></span>
    </div>
    <div v-else-if="isOptional" class="signed-optional">
      Optional
    </div>
    <div v-else-if="date" class="signed-success">
      <span>Signed: {{ parseTimestamp(date, undefined, "do MMM yyyy") }}</span>
    </div>
    <div v-else class="signed-pending">
      Awaiting signature
    </div>
  </div>
</template>

<style scoped>
.signed-optional {
  color: var(--kate-type-light);
  font-style: italic;
}

.manual-completion {
  text-align: right;
  color: var(--kate-type-success);
}

.manual-completion-note :deep(p) {
  margin: 0;
}
</style>

<script>
import TimeMixin from '@mixins/time-mixins';

export default {
  name: 'signature-date',
  mixins: [TimeMixin],

  props: {
    date: {
      type: String,
    },
    isOptional: {
      type: Boolean,
      default: false,
    },
    manualCompletionNote: {
      type: String,
      default: null,
    },
  },
};
</script>
